"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewCreateReport extends new_item_1.default {
    constructor(newCreateReport) {
        super();
        this.all = newCreateReport.all;
        this.testing = newCreateReport.testing;
    }
}
exports.default = NewCreateReport;
//# sourceMappingURL=new-createReport.js.map